import { api } from 'app/utils/api/helpers'

export const getVacancyReport = (teamId: string, params: any) => {
  return api.get(`/sm/team/${teamId}/vacancy/report`, { params })
}
